import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class NmbrsService extends BaseService<any> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'nmbrs');
    }


}


// WEBPACK FOOTER //
// ./src/app/services/nmbrs.service.ts